import React from 'react';
import { Link } from 'react-router-dom'
import {withRouter} from 'react-router-dom';
import WebAPI from '../api/WebAPI.js';
import AppCommHandler from '../api/AppCommHandler.js';
import partAccLogo from './../images/pa.svg';
import fasSetup from './../images/fasSetup.svg';
import fitTool from './../images/fasTool.svg';
import defaultLogo from './../images/admin.svg';
import comnPortalLogo from './../images/cp.svg';
import axios from 'axios';

class ApplicationItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.openURL = this.openURL.bind(this);
		this.openApp = this.openApp.bind(this);
		 this.redirectToApplication = this.redirectToApplication.bind(this);
    }
    openURL(url, newWindow, appId, external) {
    	if(external === "Y"){
	    	if(!window.confirm("Attention: You are now leaving the astfinancial.com website \n\nYou are now leaving AST's website and entering a third-party website. AST has no control over such websites and does not guarantee or endorse any opinions, ideas, products, information, content, or services offered on such sites, and makes no warranties as to the accuracy, completeness, reliability or suitability of their content. AST hereby disclaims liability for any information, materials, products or services posted or offered at any of the third-party websites. Third-party websites may have privacy and/or security policies different from that of AST. Therefore, please review the privacy and/or security policies of any third-party website when accessing their websites. \n\nClick \"OK\" to acknowledge this disclosure and view the selected website. If you click \"CANCEL\", you are acknowledging this disclosure, but you will not be able to view the information.")) {
	    		return;
	    	}
	    }
        if(newWindow === 'Y'){
            window.open(url, appId);
        } else {
            if (url.startsWith('/')){
				this.props.history.push(url)
			} else {
				if(window.hasToken(url) && window.isSameDomain(url) ){
					window.openApp(url);
				} else {
					 //logout current application, call appropriate api to terminate the session. This is not user logout this is application logout.
					 this.redirectToApplication(url);
				}
			}
        }	    
    }
    redirectToApplication(applicationURL) {
       //logout current application, call appropriate api to terminate the session. This is not user logout this is application logout.
		WebAPI.getData("/session/logout").then(res => {
            window.location.href = applicationURL;
        }
        ).catch(err => {
        	window.location.href = window.env.LOGINAPP_URL;
        })
        
    }
    handleOnClick(e) {
        this.openApp();
    	e.preventDefault();
    }
    
    openApp() {
        if (this.props.application.dynamic === 'Y') {
            WebAPI.getData('/app/' + this.props.application.id + '/url', {}).then(response => {
                this.openURL(response.data.url, this.props.application.newWindow, response.data.id, this.props.application.external);
            }).catch(errRetry => {

            });
        } else {
            this.openURL(this.props.application.url, this.props.application.newWindow, this.props.application.id,this.props.application.external);
        }
    }
    
    render(props) {

        const application = this.props.application;
		const displayLogo = () => {
			if (application.id == 'TW') {
				return <img className="app-logo" src={partAccLogo} alt="logo" />
			}
			if (application.id == 'CMP' || application.id == 'FRADR' || application.id == 'PSADM') {
				return <img className="app-logo" src={comnPortalLogo} alt="logo" />
			}
			if (application.id == 'FASSP' || application.id == 'ADHOC' || application.id == 'RPT01' || application.id == 'SOL' || application.id == 'SIS' || application.id == 'FRSBP') {
				return <img className="app-logo" src={fasSetup} alt="logo" />
			}
			if (application.id == 'FIT') {
				return <img className="app-logo" src={fitTool} alt="logo" />
			}
			return <img className="app-logo" src={defaultLogo} alt="logo" />
		}
		const displayHelp = () => {
			if (application.docAvailable === 'Y') {
				return  <a target="_blank" href={window.env.API_URL + "/DocViewer/" + application.id}> <button type="button" className="btn btn-user-guide">Help</button></a>
			}
        }
        return (
       		<div className="col-12 col-sm-6 col-md-4 col-lg-3 col-application">
                <div className="applications-wrapper" /*style={this.props.containerStyle} */ >

                    <div className="application-icon-bg" onClick={this.handleOnClick}>
                        {displayLogo()}
                    </div>
                    <div className="application-title-row">
                        <h3 className="application-title" onClick={this.handleOnClick}>{application.name}</h3>
					</div>
                    <div className="application-title-row">
                        <div class="application-title-desc" >{application.appDesc}</div>
					</div>
                    <div className="application-buttons-wrapper">
						{displayHelp()}
                        <button type="button" className="btn btn-primary btn-application" onClick={this.handleOnClick}>
                            {/* <span className="icon-form-check-multiple-marked-outline"></span>*/}Launch 
                        </button>
                    </div>

                </div>
            </div>

        );
    }
}

export default withRouter(ApplicationItem);